const ARTICLE_CONTACT_FORM_SELECTOR = '.article-content form[action*="/contact"]';

class ArticleContactForms {
  constructor() {
    this.settings = document.querySelector('[data-article-contact-form-settings]');
    this.forms = Array.from(document.querySelectorAll(ARTICLE_CONTACT_FORM_SELECTOR));
  }

  init() {
    if (!this.settings) {
      return;
    }

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get("contact_posted") === "true") {
      currentUrl.searchParams.delete("contact_posted");
      window.history.replaceState({}, "", `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      this.forms.forEach((form) => this.showStatus(form, "success"));
      return;
    }

    this.forms.forEach((form) => {
      form.addEventListener("submit", this.onSubmit.bind(this));
    });
  }

  async onSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    if (!form.reportValidity()) {
      return;
    }

    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    this.setPendingState(submitButton, true);
    this.removeStatus(form);

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin",
        redirect: "follow",
      });
      const responseUrl = new URL(response.url, window.location.origin);

      if (!response.ok || responseUrl.searchParams.get("contact_posted") !== "true") {
        throw new Error("Contact form submission was not successful.");
      }

      this.showStatus(form, "success");
    } catch (error) {
      console.error(error);
      this.showStatus(form, "error");
      this.setPendingState(submitButton, false);
    }
  }

  setPendingState(submitButton, isPending) {
    if (!submitButton) {
      return;
    }

    submitButton.disabled = isPending;
    submitButton.setAttribute("aria-busy", String(isPending));
  }

  removeStatus(form) {
    form.parentElement?.querySelector('[data-article-contact-form-status]')?.remove();
  }

  showStatus(form, status) {
    if (status === "success") {
      this.showSuccess(form);
      return;
    }

    const confirmation = document.createElement("div");
    confirmation.className = "form-errors";
    confirmation.dataset.articleContactFormStatus = "";
    confirmation.setAttribute("role", "alert");
    confirmation.setAttribute("tabindex", "-1");
    confirmation.textContent = this.settings.dataset.errorMessage;

    form.insertAdjacentElement("beforebegin", confirmation);
    confirmation.focus();
  }

  showSuccess(form) {
    const confirmation = document.createElement("div");
    confirmation.className = "contact-success";
    confirmation.dataset.articleContactFormStatus = "";
    confirmation.setAttribute("role", "status");
    confirmation.setAttribute("tabindex", "-1");

    const icon = document.createElement("div");
    icon.className = "contact-success__icon";
    icon.setAttribute("aria-hidden", "true");
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "28");
    svg.setAttribute("height", "28");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle.setAttribute("cx", "12");
    circle.setAttribute("cy", "12");
    circle.setAttribute("r", "12");
    circle.setAttribute("fill", "currentColor");
    const checkmark = document.createElementNS("http://www.w3.org/2000/svg", "path");
    checkmark.setAttribute("d", "M7.5 12.25L10.5 15.25L16.5 8.75");
    checkmark.setAttribute("stroke", "white");
    checkmark.setAttribute("stroke-width", "2");
    checkmark.setAttribute("stroke-linecap", "round");
    checkmark.setAttribute("stroke-linejoin", "round");
    svg.append(circle, checkmark);
    icon.append(svg);

    const content = document.createElement("div");
    content.className = "contact-success__content";
    const title = document.createElement("h2");
    title.className = "contact-success__title";
    title.textContent = this.settings.dataset.successTitle;
    const message = document.createElement("p");
    message.className = "contact-success__text";
    message.textContent = this.settings.dataset.successMessage;
    content.append(title, message);

    const button = document.createElement("a");
    button.className = "button button--xl contact-success__button";
    button.href = `${window.location.pathname}${window.location.search}${form.id ? `#${form.id}` : ""}`;
    button.textContent = this.settings.dataset.successButton;

    confirmation.append(icon, content, button);
    form.replaceWith(confirmation);
    confirmation.focus();
  }
}

new ArticleContactForms().init();
